import { render, staticRenderFns } from "./ExchangeCard.vue?vue&type=template&id=3db3e7d8&scoped=true"
import script from "./ExchangeCard.vue?vue&type=script&lang=ts"
export * from "./ExchangeCard.vue?vue&type=script&lang=ts"
import style0 from "./ExchangeCard.vue?vue&type=style&index=0&id=3db3e7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db3e7d8",
  null
  
)

export default component.exports